/* tslint:disable */
/* eslint-disable */
export enum FirmwareSortColumn {
  ReleaseUser = 'RELEASE_USER',
  ReleaseDate = 'RELEASE_DATE'
}
